import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(0.5),
            margin: theme.spacing(1, 0.5),
            '& span': {
                fontSize: 14,
                color: theme.palette.text.secondary,
            },
        },
    }
})

export default useStyles
